import {defer} from "lodash";
import ActiveService from "rapid/service.active";
import {update} from "rapid/reference.helper";

export class AuthService extends ActiveService {
    /**
     *
     * @param $injector
     * @param $httpConfigurator
     * @param $rootScope
     */
    constructor($injector, $httpConfigurator, $rootScope) {

        "ngInject";
        super($injector);

        this.$injector = $injector;
        this.$httpConfigurator = $httpConfigurator;
        this.$rootScope = $rootScope;

        this.permission = null;


        if (this.isAuthenticated()) {
            this.$httpConfigurator.setHeaders(this.getToken());
        }
        this.user = this.getUser();

    }

    getUser() {
        let user = this.cacheGet("user");
        update(this.user, user);
        return user;
    }

    isRole(role) {
        let user = this.getUser();
        let roles = user.groups_names;
        return roles.indexOf(role) !== -1;
    }

    setUser(user) {
        return this.cacheSet("user", user);
    }

    getToken() {
        return this.cacheGet("token");
    }

    setToken(token) {
        return this.cacheSet("token", `Token ${token}`);
    }

    /**
     *
     * @param state
     * @returns {boolean}
     */
    isNull(state) {
        return null != state;
    }

    /**
     *
     * @returns {boolean}
     */
    isAuthenticated() {
        return (
            this.isNull(this.getToken()) &&
            this.isNull(this.getUser())
        );
    }

    logout() {
        let cacheClear = () => {
            this.$httpConfigurator.clearHeaders();
            this.cacheRemove("user");
            this.cacheRemove("token");
            this.cacheRemove("company");
            this.cacheRemove("config");
            defer(() => window.location.reload());
        };

        if (this.isAuthenticated()) {
            this.post(this.config.API.Logout, {}, {ignore401: true}).finally(() => cacheClear());
        }
    }

    /**
     *
     * @returns {*|Promise.<TResult>}
     */
    me() {
        return new Promise((resolve, reject) => {
            this.get(this.getUser().url)
                .then(user => {
                    this.setUser(user);
                    update(this.user, user);
                    this.fetchPermissions(this.user)
                        .then(() => resolve())
                        .catch(() => reject());
                });
        });
    }

    fetchPermissions(user) {
        return new Promise((resolve, reject) => {
            if (user.groups[0]) {
                this.get(user.groups[0])
                    .then((data) => {
                        this.permission = data;
                        this.$rootScope.$emit("$updatePermissions", true);
                        resolve(data);
                    })
                    .catch((err) => reject(err));
            } else {
                reject();
            }
        });
    }

    getPermissions() {
        if (this.permission) {
            return this.permission.name;
        }
    }

    finalizeLogin(data) {
        if (!data || !data.key || !data.user) {
            console.error("finalizeLogin: data, key, or user is undefined", data);
            return Promise.reject(new Error("Invalid data for finalizeLogin"));
        }
        this.setToken(data.key);
        this.setUser(data.user);
        this.$httpConfigurator.setHeaders(this.getToken());
        this.user = this.getUser();
        return this.fetchPermissions(this.user);
    }

    /**
     *
     * @param data
     * @returns {Function}
     */
    authenticate(data,fromTwoFactor = false) {
        return new Promise((resolve, reject) => {
            this.post(this.config.API.Login, data)
                .then(data => {
                    if (data.requires_2fa) {
                        resolve(data);
                        return;
                    }
                    if (fromTwoFactor) {
                        resolve(data);
                        return;
                    }
                    this.finalizeLogin(data)
                        .then(() => resolve())
                        .catch((err) => console.log(err));
                })
                .catch(errors => {
                    if (fromTwoFactor){
                        this.notify.set(this.translate(errors.data.detail), "error");
                    } else {
                        this.notify.set(this.translate("Please provide valid email and password"), "error");
                    }
                    reject(errors);
                });
        });
    }

    twoFactorAuthenticationState(data) {
        return new Promise((resolve, reject) => {
            this.post(this.config.API.TwoFactor, data)
                .then((resp) => {
                    let user = this.getUser();
                    Object.assign(user,{two_factor_enabled: data.enable});
                    this.setUser(user);
                    resolve(resp);
                })
                .catch(errors => {
                    this.notify.set(this.translate("2Factor Authentication change state is fail."), "error");
                    reject(errors);
                });
        });
    }

}



// WEBPACK FOOTER //
// ./sources/services/auth.js